import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    user: null,
    assignment: null,
    assignmentHeader: null,
    nav: null,
    navIndex: 0,
    recordingEng: false
  },
  mutations: {
    updateUser(state, payload) {
      state.user = payload
    },
    setAssignment(state, payload) {
      state.assignment = payload
    },
    setAssignmentHeader(state, payload) {
      state.assignmentHeader = payload
    },
    setNav(state, payload) {
      state.nav = payload
    },
    setNavIndex(state,payload) {
      state.navIndex = payload
    },
    setRecordingEng(state,payload) {
      state.recordingEng = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },
  actions: {

  }
})
